<script setup lang="ts">
import type { KjdsListPageProps } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsListPageProps>(), {})

console.log('article: kjdsPageConfig', props.kjdsPageConfig)

const app = useNuxtApp()
const route = useRoute()
const storeIndex = useStoreIndex()
const storeArticleList = useStoreArticleList()

const baseTitle = 'レポート'
let headTitle = baseTitle

const pageData = {
  items: [] as Article[],
  objects: [] as ArticleObject[],
  meta: {} as ApiMeta,
}

const setHead = () => {
  if (route.query.sort === 'pv_last_month') {
    headTitle = `${baseTitle}ランキング`
  }

  let items = []
  const headDescription = `展覧会の取材レポート。実際の会場で取材した様子を、写真や動画で紹介。行ったからこそ分かる展覧会の見どころとポイントを分かりやすくお伝えします。展覧会に出かける前に、アイエムをチェック！`
  items = [
    {
      text: headTitle,
      disabled: true,
    },
  ]
  storeIndex.setBreadCrumbs(items)

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const initPage = async () => {
  const options: KjdsFetchListOptions = { query: { ...route.query } }
  const [_resSite, _resMaster, resList] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchList(props.kjdsPageConfig.list.mainListName, options),
  ])
  pageData.items = resList.data.articles as Article[]
  pageData.objects = resList.data.article_objects
  pageData.meta = resList.meta

  console.log('article: initPage', pageData)
}
await initPage()
setHead()
</script>

<template>
  <div class="p-main">
    <h2 class="c-heading_page">
      {{ headTitle }}
    </h2>

    <div class="p-main_result">
      <div class="p-main_list">
        <ReportItem
          v-for="item in pageData.items"
          v-bind:key="item.id"
          v-bind:item="item"
          v-bind:objects="pageData.objects"
        />
      </div>

      <Pagination
        v-bind:page="pageData.meta.page_no"
        v-bind:length="pageData.meta.total_page"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.p-main {
  &_result {
    position: relative;
  }

  &_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 100%;
    margin-bottom: 60px;

    @include responsive.mq_down(sp) {
      margin-bottom: 50px;
    }
  }
}
</style>
